import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export interface CustomerForm {
  id?: string;
  first_name: string;
  last_name: string;
  gender?: string;
  birth_date?: string;
  marital_status?: string;
  children_count?: string;
  children_age?: string;
  occupation?: string;
  company?: string;
  phone: string;
  email: string;
  district?: string;
  city?: string;
  purchase_reason?: string;
  housing_type?: string;
  reference_source?: string;
  referral_name?: string;
  signature?: string;
  kvkk_accepted?: string;
  created_at?: string;
}
